import { render, staticRenderFns } from "./register-jobseeker.vue?vue&type=template&id=5ae5b45d"
import script from "./register-jobseeker.vue?vue&type=script&lang=js"
export * from "./register-jobseeker.vue?vue&type=script&lang=js"
import style0 from "./register-jobseeker.vue?vue&type=style&index=0&id=5ae5b45d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports